<template>
  <LabelledInput
    :label="paramObject.label"
    :helpful-tip="paramObject.description"
    :disabled="disabled"
  >
    <b-input-group>
      <b-input
        v-model="param"
        type="number"
        :min="paramObject.min"
        :max="paramObject.max"
        :step="paramObject.step"
        style="max-width: 5em;"
      />
      <b-input
        v-model="param"
        type="range"
        :min="paramObject.min"
        :max="paramObject.max"
        :step="paramObject.step"
        class="px-0"
      />
    </b-input-group>
  </LabelledInput>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import { BubbleParamsConfig } from '@/types'

export interface BubbleParams {
  name: keyof BubbleParamsConfig
  label: string
  min: number
  max: number
  step: number
  description: string
}

const components = {
  LabelledInput,
}

const props = {
  paramObject: {
    type: Object as PropType<BubbleParams>,
    default: () => {
      return {
        name: 'paramName',
        label: 'label',
        min: 0,
        max: 1,
        step: 0.01,
        description: 'Description goes here',
      }
    },
  },
  disabled: Boolean,
}

@Component({ components })
export default class BubbleParamSlider extends Vue.extend({ props }) {
  get param () {
    return this.$typedStore.primary.app.config.bubbleParams[this.paramObject.name as keyof BubbleParamsConfig]
  }

  set param (newValue) {
    this.$typedStore.visualisationApp.updateBubbleParams({
      param: this.paramObject.name as keyof BubbleParamsConfig,
      value: Number(newValue),
    })
  }
}

</script>
